import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { UpgradeAcceleratorForm } from "@/model/interface/CalculatorTypes";
import HomeEstimatedValue from "@/components/shared/HomeEstimatedValue";
import UpgradeBudget from "@/components/shared/UpgradeBudget";
import { ApplicationType } from "@/enum/ApplicationType";
import ProductShareInformation from "@/components/shared/ProductShareInformation";
import { useTitle } from "@/components/provider/TitleProvider";
import { isDebugForms } from "@/util/debug";

const DoubleBoostCalculator = () => {
  const navigate = useNavigate();
  const { title, setTitle } = useTitle();

  useEffect(() => {
    setTitle("");
  }, []);

  const contextForm = useForm<UpgradeAcceleratorForm>({
    mode: "onTouched",
    defaultValues: {},
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = contextForm;

  const onSubmit = (data: UpgradeAcceleratorForm) => {
    navigate("/double-boost/register");
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isDebugForms()) {
      navigate("/double-boost/register");
    } else {
      handleSubmit(onSubmit)(e);
    }
  };

  return (
    <FormProvider {...contextForm}>
      <form onSubmit={handleFormSubmit}>
        <div className="w-full max-w-2xl mx-auto px-4 py-6 space-y-6">
          <h3 className="text-4xl font-semibold text-gray-900">Double Boost Calculator</h3>
          <HomeEstimatedValue fieldPrefix="context" />
          <UpgradeBudget fieldPrefix="context" />
          <ProductShareInformation applicationType={ApplicationType.UpgradeAccelerator} fieldPrefix={"context"} />
          <div className="flex justify-center pt-2">
            <button
              type="submit"
              className="inline-flex items-center rounded-full bg-[#9BFBE0] px-8 py-3 text-sm font-medium text-[#010305] shadow-sm hover:shadow-md transition-all"
            >
              Get Started
            </button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

DoubleBoostCalculator.propTypes = {};

export default DoubleBoostCalculator;
